const normalizeText = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase();

export const isSalonKdsOrder = (order = {}) => {
  const orderId = String(order.orderId || order.id || '').trim().toUpperCase();
  const source = normalizeText(
    order.source || order.salesChannel || order.channel || order.origin || ''
  );
  const fulfillment = normalizeText(order.fulfillment || order.orderType || '');

  return orderId.startsWith('SALAO-') || source.includes('salao') || fulfillment === 'dine_in';
};

export const shouldShowKdsRoute = (order = {}) => !isSalonKdsOrder(order);
